<template>
  <div class="assets-collection-confirm">
    <MovementDetails
      v-if="!showSuccess && !showMfa"
      :is-loading="isLoading"
      title="Resumo da negociação"
      :section="movementDetailsSections[tradeType]"
      :actions-buttons="movementDetailsActions"
      @click="movementActions"
    >
      <template v-slot:conteudo>
        <v-container class="pa-0 mt-6 primary--text">
          <BaseResumeInfos :resume-infos="infos" />
        </v-container>
      </template>
      <template v-slot:dados-pagamento>
        <div
          v-if="tradeType == 'select'"
          class="d-flex mt-7"
        >
          <BaseDataBank
            :has-icon="false"
            :bank-value="getBankCodeAndName(bankAccountOrTradingPartner)"
            :agency-value="getAgencyAndDigit(bankAccountOrTradingPartner)"
            :account-value="getNumberAndDigit(bankAccountOrTradingPartner)"
            style="border: none; width: 100%; padding: 0px!important"
          />
        </div>
        <div
          v-else-if="tradeType == 'dynamic'"
          class="mt-7"
        >
          <p class="mb-2">
            Nome: <b>{{ bankAccountOrTradingPartner.name }}</b>
          </p>
          <p v-if="bankAccountOrTradingPartner.tax_number">CNPJ: <b>{{ $options.filters.maskCPForCNPJ(bankAccountOrTradingPartner.tax_number) }}</b></p>
          <v-divider class="my-6" />
          <v-checkbox
            v-model="confirmOperation"
            label="Estou de acordo com os dados simulados e desejo solicitar a operação."
          />
        </div>
      </template>
    </MovementDetails>

    <v-card
      v-else
      :class="{ 'assets-collection-confirm__card--feedback-background': showSuccess }"
      :elevation="showMfa ? '2' : '0'"
    >
      <div
        class="app-align-items-center justify-center"
        :class="{ 'py-12' : showMfa }"
      >
        <v-card-title>
          <div>
            <div
              class="platform-home body-1"
              :class="'text-' + stepDetailInvite.textAlignment"
            >
              <div v-html="stepDetailInvite.content" />

              <template v-if="stepDetailInvite.input">
                <v-form v-model="formValid">
                  <BaseInput
                    v-model="inputModel"
                    :rules="executeValidation(inputModel)"
                    counter="6"
                    type="password"
                    :error="errorMsg ? true : false"
                    :error-messages="errorMsg"
                    :label="stepDetailInvite.input.label"
                    class="my-10"
                    @input="errorMsg = null"
                  />
                </v-form>
              </template>
            </div>
          </div>
        </v-card-title>
      </div>
      <v-card-actions :class="{ 'mt-7 card-actions--footer': showMfa }">
        <v-col
          :class="'text-' + stepDetailInvite.actions[0].alignment"
          class="pa-2"
        >
          <BaseButton
            color="primary"
            button-class="mr-2"
            :type="stepDetailInvite.actions[0].type"
            @click="stepDetailInvite.actions[0].dispatchEvent"
          >
            {{ stepDetailInvite.actions[0].cancelButtonText }}
          </BaseButton>
        </v-col>
        <v-col
          v-if="stepDetailInvite.actions.length > 1"
          :class="'text-' + stepDetailInvite.actions[1].alignment"
          class="pa-2"
        >
          <BaseButton
            color="primary"
            button-class="mr-2"
            :is-disabled="!formValid"
            @click="stepDetailInvite.actions[1].dispatchEvent"
          >
            {{ stepDetailInvite.actions[1].cancelButtonText }}
          </BaseButton>
        </v-col>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import BaseResumeInfos from '../BaseResumeInfos'
import BaseDataBank from '../BaseDataBank'
import MovementDetails from '../MovementDetails'
import UtilsBankAccount from '../../mixins/UtilsBankAccount'

export default {
  components: { BaseResumeInfos, BaseDataBank, MovementDetails },
  mixins: [UtilsBankAccount],
  props: {
    totalOfAssets: {
      default: 0,
      type: Number
    },
    amount: {
      default: 0.00,
      type: Number
    },
    bankAccountOrTradingPartner: {
      default: () => {},
      type: Object
    },
    tradeType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      showSuccess: false,
      showMfa: false,
      inputModel: '',
      formValid: false,
      errorMsg: null,
      infos: [
        {
          icon: 'request_quote',
          iconText: 'Quantidade',
          value: `${this.totalOfAssets} ativos`,
          valueType: 'text'
        },
        {
          icon: 'attach_money',
          iconText: 'Valor total',
          value: this.amount,
          valueType: 'currency'
        }
      ],
      movementDetailsSections: {
        "select": [
          {
            title: 'CONTEÚDO',
            value: 'conteudo'
          },
          {
            title: 'DADOS DE PAGAMENTO',
            subtitle: 'Ao final da operação o pagamento será efetuado na conta abaixo',
            value: 'dados-pagamento'
          }
        ],
        "dynamic": [
          {
            title: 'CONTEÚDO',
            value: 'conteudo'
          },
          {
            title: 'DADOS DO FIDC',
            subtitle: 'Ao final da operação os contratos serão cedidos para o FIDC abaixo',
            value: 'dados-pagamento'
          }
        ]
      },
      confirmOperation: false
    }
  },
  computed: {
    ...mapState({
      programDraftMovementId: state => state.programDraftMovements.programDraftMovementId,
      programDraftMovementData: state => state.programDraftMovements.programDraftMovementData,
      programConfiguration: (state) => state.platformProgram.programInfo ? state.platformProgram.programInfo.configuration : null,
      movementDetailsActions(){
        return [
          {
            text: 'VOLTAR',
            type: 'text',
            color: 'primary',
            dispatchEvent: 'onCancel'
          },
          {
            text: 'ENVIAR',
            color: 'primary',
            dispatchEvent: this.hasConfigMfa ? 'onConfirmMfa' : 'onConfirm',
            disabled: this.isLoading || (this.tradeType == 'dynamic' && !this.confirmOperation)
          }
        ]
      }
    }),
    hasConfigMfa(){
      return this.programConfiguration && this.programConfiguration['finish_draft_request_mfa'] && this.programConfiguration['finish_draft_request_mfa'] == 'true' ? true : false
    },
    stepDetailInvite() {
      let context = this.showMfa ? 'mfa' : 'success'
      let stepDetail = {
      "success": {
        content: `
          <img src="${require('@/assets/action-success.svg')}" height="148" width="143" class="mb-6 mt-2"/>
          <h3 class="headline mb-4 text-center primary--text font-weight-bold">Negociação enviada!</h3>
          <p class="mb-1">Acesse o menu negociações para acompanhar <br />tudo o que você enviou.</p>
        `,
        textAlignment: 'center',
        actions: [{
          alignment: 'center',
          cancelButtonText: 'Fechar',
          dispatchEvent: () => this.closeAssetsCollectionConfirm()
        }]
      },
      "mfa": {
        content: `
          <h3 class="headline mb-4 text-center primary--text font-weight-bold">Código de autenticação multifator</h3>
        `,
        textAlignment: 'left',
        input: {
          label: 'Digite o código'
        },
        actions: [
          {
            alignment: 'left',
            cancelButtonText: 'Voltar',
            type: 'text',
            dispatchEvent: () => this.backToAssetsCollection()
            ,
          },
          {
            alignment: 'right',
            cancelButtonText: 'Enviar',
            dispatchEvent: () => this.validateCode(this.inputModel)
          }
        ]
      }
    }
      return stepDetail[context]
    }
  },
  methods: {
    ...mapActions('programDraftMovements', ['apiUpdateDraftMovement']),
    executeValidation(){
      return [this.isValid, this.isOnlyNumber, v => v.length == 6 || 'O código deve ter 6 números']
    },
    validateCode(code){
      if(code.length == 6 && code === '123456'){
        this.errorMsg = null
        this.sendAssetsCollection()
      } else {
        this.errorMsg = 'Código de autenticação inválido.'
      }
    },
    movementActions(event) {
      const { dispatchEvent, ev} = event
      switch(dispatchEvent) {
        case 'onConfirm':
          this.sendAssetsCollection()
          break;
        case 'onCancel':
          this.backToAssetsCollection()
          break;
        case 'onConfirmMfa':
          this.showMfa = true
          break;
      }
    },
    backToAssetsCollection() {
      this.$emit('back-page')
    },
    closeAssetsCollectionConfirm() {
      this.$emit('close-assets-collection')
      this.$emit('updateAssetList')
    },
    async sendAssetsCollection(){
      this.showMfa = false;
      this.isLoading = true
      const data = {
        "type": "trade",
        "id": this.programDraftMovementId,
        "data": {
          "action": "",
          "data": {}
        }
    	}
      if(this.tradeType === "select") {
        data.data.action =  "request";
        data.data.data = {
          bank_account: this.bankAccountOrTradingPartner
        }
      } else if (this.tradeType === "dynamic") {
        data.data.action =  "finish";
        data.data.data = {
          'fidc_name': this.bankAccountOrTradingPartner.name,
          'fidc_tax_number': this.bankAccountOrTradingPartner.tax_number
        }
      }
      try {
        await this.apiUpdateDraftMovement(data)
        this.$emit('updateAssetList')
        setTimeout(() => {
          this.showSuccess = true
          this.$emit('updateAssetList')
          this.isLoading = false
        }, 11000)
      } catch (e) {
        throw e
      }
    }
  }
}
</script>

<style scoped>

.card-actions--footer {
  background-color: var(--v-grayf8-base);
}

.assets-collection-confirm__card--feedback-background{
  background: transparent;
}

</style>
